import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTabs, { tabsProps } from "../../../../../../components/Tabs";
import IncomeTax from "./IncomeTax";
import ProfessionalTax from "./ProfessionalTax";

const TaxesAndDeductions = () => {
    const locations = useLocation();
    const navigateto = useNavigate();
    const [activeTab] = React.useState<string>(locations.pathname);

    const Tabs: tabsProps[] = [
        { key: 'income-tax', label: 'Income Tax', content: <IncomeTax /> },
        { key: 'professional-tax', label: 'Professional Tax', content: <ProfessionalTax /> },
    ]

    useEffect(() => {
        navigateto(`${activeTab}/${Tabs[0].key}`, { replace: true });
    }, []);

    const onTabChange = (activeKey: string) => {
        console.log(activeKey);
    }

    return <CustomTabs tabs={Tabs} routes={true} onTabChange={onTabChange} />
}

export default TaxesAndDeductions;